import { Link2, Sparkles, Store, UserRound } from "lucide-react";
import { COMANDOS } from "./modelos";

const ICONES = { nome: UserRound, empresa: Store, link: Link2 };

/** Trecho do texto em volta do {{n}}, pra loja saber o que completar. */
function contexto(corpo, n) {
  const [antes = "", depois = ""] = corpo.split(`{{${n}}}`);
  return {
    a: antes.replace(/\{\{\d+\}\}/g, "…").slice(-30).trimStart(),
    d: depois.replace(/\{\{\d+\}\}/g, "…").slice(0, 30).trimEnd(),
  };
}

/**
 * Modelo pronto já vem preenchido: o sistema deduz o que é nome do cliente,
 * nome da loja e link rastreável. Aqui só aparece o resumo e, quando algum
 * campo não dá pra deduzir, um campo simples pra completar a frase.
 */
export default function CamposModelo({ corpo, campos, setCampos }) {
  const automaticos = [...new Set(campos.filter((c) => c.tipo !== "texto").map((c) => c.tipo))];
  const mudar = (i, texto) => setCampos(campos.map((c, j) => (j === i ? { ...c, texto } : c)));
  return (
    <div className="space-y-3">
      {automaticos.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 rounded-xl bg-[#25d366]/10 p-3 text-sm">
          <Sparkles className="h-4 w-4 text-[#25d366]" />
          <span className="text-muted-foreground">O sistema preenche sozinho:</span>
          {automaticos.map((t) => {
            const Icone = ICONES[t];
            return (
              <span key={t} className="inline-flex items-center gap-1 rounded-full bg-background px-2.5 py-0.5 text-xs font-semibold">
                <Icone className="h-3.5 w-3.5 text-[#25d366]" /> {COMANDOS[t].rotulo}
              </span>
            );
          })}
        </div>
      )}
      {campos.map((c, i) => {
        if (c.tipo !== "texto") return null;
        const { a, d } = contexto(corpo, i + 1);
        return (
          <label key={i} className="block">
            <span className="text-sm font-semibold">Complete a mensagem</span>
            <span className="mt-1.5 flex flex-wrap items-center gap-1.5 rounded-lg border bg-background px-3 py-2 text-sm">
              <span className="text-muted-foreground">…{a}</span>
              <input value={c.texto} onChange={(e) => mudar(i, e.target.value)} maxLength={60} placeholder="escreva aqui"
                className="min-w-[140px] flex-1 rounded-md border border-dashed border-[#25d366] bg-[#25d366]/5 px-2 py-0.5 outline-none" />
              <span className="text-muted-foreground">{d}…</span>
            </span>
          </label>
        );
      })}
    </div>
  );
}
